// File: frontend/src/services/clientPortalService.js
// Version: 1.0
// Date: 2026-04-11
// Description: API service for client portal endpoints — cases, documents, messages.

import apiService from './apiService';

const clientPortalService = {
  async getCases() {
    return apiService.makeRequest('/client/me/cases');
  },

  async getCase(caseId) {
    return apiService.makeRequest(`/client/me/cases/${caseId}`);
  },

  async getCaseDocuments(caseId) {
    return apiService.makeRequest(`/client/me/cases/${caseId}/documents`);
  },

  async getMessages(caseId) {
    return apiService.makeRequest(`/client/me/cases/${caseId}/messages`);
  },

  async sendMessage(caseId, body) {
    return apiService.makeRequest(`/client/me/cases/${caseId}/messages`, {
      method: 'POST',
      body: JSON.stringify({ body }),
    });
  },
};

export default clientPortalService;
